import React from 'react';
import { calculatePathDuration } from '../utils/pathCalculations';
import '../../styles/modes/customMode.css';

const PathDistance = ({ customPath, connections, demand, modeCapacities, onDurationCalculated }) => {
  if (customPath.length <= 1) return null;
  
  // Calculate base duration (single trip) - returns string, convert to number
  const singleTripDuration = parseFloat(calculatePathDuration(customPath, connections || [])) || 0;
  
  // Calculate capacity-adjusted duration if demand > 0
  let totalDuration = singleTripDuration;
  if (demand > 0 && modeCapacities) {
    totalDuration = 0;
    
    for (let i = 0; i < customPath.length - 1; i++) {
      const fromPoint = customPath[i];
      const toPoint = customPath[i + 1];
      
      // Find matching connection
      const connection = connections.find(conn => 
        (conn.points[0]?.id === fromPoint.id && conn.points[1]?.id === toPoint.id) ||
        (conn.points[1]?.id === fromPoint.id && conn.points[0]?.id === toPoint.id)
      );
      
      if (connection) {
        const capacity = modeCapacities[connection.transportMode] || 0;
        const segmentDuration = connection.duration || 0;
        
        if (capacity > 0) {
          const trips = Math.ceil(demand / capacity);
          totalDuration += segmentDuration * trips;
        } else {
          totalDuration += segmentDuration;
        }
      }
    }
  }
  
  // Don't notify on every render - let parent decide when to save
  
  return (
    <div className="path-distance">
      Path Duration: {(totalDuration && typeof totalDuration === 'number' && totalDuration > 0) ? `${totalDuration.toFixed(1)} hours` : 'No duration data'}
    </div>
  );
};

export default PathDistance;
